import { LandmarkIcon } from "lucide-react";

import { Skeleton } from "@/components/skeleton";
import { cn } from "@/utils/cn";

import { CardBrandMark } from "../../../components/CardBrandMark";
import { usePaymentMethods } from "../../../components/payment-methods/hooks/usePaymentMethods";

interface AccountPaymentMethodsCardProps {
  readonly projectId: number;
}

export function AccountPaymentMethodsCard({
  projectId,
}: AccountPaymentMethodsCardProps) {
  const { data, isPending } = usePaymentMethods(projectId);
  const paymentMethods = data
    ? [data.defaultMethod, ...data.backupMethods]
    : [];

  return (
    <div className="flex flex-col gap-lg rounded-xl border border-border-secondary bg-bg-primary px-3xl py-xl">
      <h3 className="text-xl font-semibold text-text-primary">
        Payment methods
      </h3>

      {isPending && <Skeleton className="h-16 w-full rounded-md" />}

      <ul className="flex flex-col gap-xs">
        {paymentMethods.map((paymentMethod, index) => (
          <li
            className={cn(
              "flex items-center gap-md rounded-md p-md",
              index === 0 && "bg-bg-secondary",
            )}
            key={paymentMethod.id}
          >
            {paymentMethod.type === "card" ? (
              <CardBrandMark brand={paymentMethod.brand} />
            ) : (
              <span className="flex h-10 w-14.5 shrink-0 items-center justify-center rounded-md border border-border-secondary bg-bg-primary">
                <LandmarkIcon
                  aria-hidden="true"
                  className="text-text-primary"
                  size={24}
                />
              </span>
            )}
            <span className="text-sm font-medium text-text-primary">
              •••• {paymentMethod.last4}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
